import { z } from "zod";
import { BIRTH_DATE_REGEX, PHONE_NUMBER_REGEX } from "./registration.input";

export const accountProfileInput = z.object({
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  street: z.string().nullish(),
  zipCode: z.string().nullish(),
  city: z.string().nullish(),
  phoneNumber: z
    .string()
    .regex(PHONE_NUMBER_REGEX, "errorPhoneNumberNotValid")
    .nullish(),
  countryCode: z.string().nullish(),
  socialSecurityNumber: z.string().nullish(),
  birthDate: z
    .string()
    .regex(BIRTH_DATE_REGEX, "errorBirthDateInvalid")
    .nullish(),
  companyName: z.string().nullish(),
  companyOrganizationalNumber: z.string().nullish(),
});

export type AccountProfileInput = z.infer<typeof accountProfileInput>;
